/**
 * Gateway selection. Returns the active `WorkforceGateway` implementation.
 *
 * P1: always the production `ApiGateway`. P2 adds the demo branch here — gated by
 * a build/runtime flag and loaded via dynamic import so the demo module graph is
 * code-split out of production bundles when the flag is off.
 */
import { ApiGateway } from './ApiGateway.js';
import type { WorkforceGateway } from './types.js';

let instance: WorkforceGateway | null = null;

export function makeGateway(): WorkforceGateway {
  if (!instance) instance = new ApiGateway();
  return instance;
}

export type { WorkforceGateway } from './types.js';
